import { Box, useTheme } from '@chakra-ui/react'
import React from 'react'
import CarouselForComponents from '../carouselCustom/carouselCustom'
import resource17 from '../../innerAsstes/Logos certificaciones/UTN blanco.svg'
import resource18 from '../../innerAsstes/Logos certificaciones/oiepblanco.svg'
import resource19 from '../../innerAsstes/Logos certificaciones/camarablanco.svg'
import resource20 from '../../innerAsstes/Logos certificaciones/universitam blanco.svg'
import { useAppContext } from '../../App'

export default function Certificates() {
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile);
  return (
    <div style={style.container} className='sansation-bold'>
      <Box as={'div'}>
        <p style={style.title1}>
          Nuestros cursos cuentan con
        </p>
        <p style={style.title2}>
          CERTIFICACIÓN NACIONAL E INTERNACIONAL
        </p>
      </Box>
      <CarouselForComponents
        qtyPerView={isMobile? 1 : 3} 
        customStyles={style.carousel}
      >
        <img style={style.img} src={resource17} alt='resource-17'/>
        <img style={style.img} src={resource19} alt='resource-19'/>
        <img style={style.img} src={resource18} alt='resource-18'/>
        <img style={style.img} src={resource20} alt='resource-20'/>
        <img style={style.img} src={resource17} alt='resource-17'/>
      </CarouselForComponents>
    </div>
  )
}

const styles = (theme, isMobile) => ({
  container:{
    display: 'flex',
    flexDirection: isMobile? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingLeft: '6vw',
    paddingRight: '6vw',
    padding: '3vw',
    backgroundColor: theme.background.secondary
  },
  title1:{
    fontSize: isMobile? '1.5rem' : '2rem',
    textAlign: isMobile? 'center' : 'left',
    color: theme.color.text.primary
  },
  title2:{
    fontSize: isMobile? '1.5rem' : '2.5rem',
    textAlign: isMobile? 'center' : 'left',
    color: theme.color.text.primary
  },
     img:{
    maxWidth: isMobile ? '50vw' : '18vw',
    width: '100%',
    height: 'auto',
    margin: '1rem',
    display: 'block',
    objectFit: 'contain',
  },
  carousel:{
      display: 'flex',
      width: isMobile? '80%':'60%',
      alignItems: 'center',
  }
})
